import type { QueryClient } from 'react-query'
import { entitiesCache } from '@/utils/entitiesCache'
import { invalidateDesignerTreeCache } from '@/runtime/designerTree'
import { pruneWorkspaceTabsForObjects } from './pruneWorkspaceTabs'

export const ENTITIES_RELOAD_EVENT = 'softlavka:entities-reload'

export type FlushAppAfterModuleChangeOpts = {
  removedObjectNames?: string[]
  currentPath?: string | null
  queryClient?: QueryClient
}

/**
 * Client state that still names objects a module uninstall just deleted.
 * Sidebar entities, designer tree, config menus, and workspace tabs.
 */
export function flushAppAfterModuleChange(
  connectionId: string,
  opts: FlushAppAfterModuleChangeOpts = {},
): string | null {
  if (!connectionId) return null

  entitiesCache.clear(connectionId)
  invalidateDesignerTreeCache(connectionId)

  opts.queryClient?.invalidateQueries(['config-menus', connectionId])

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(ENTITIES_RELOAD_EVENT, { detail: { connectionId } }),
    )
  }

  return pruneWorkspaceTabsForObjects(
    opts.removedObjectNames ?? [],
    opts.currentPath,
  )
}
